export const MOTORWAY_URL = 'https://motorway.co.uk';
export const PRO_URL = 'https://pro.motorway.co.uk';
export const HELP_URL = 'https://help.motorway.co.uk/hc/en-gb';
export const YOUTUBE_EMBED_URL = 'https://www.youtube-nocookie.com/embed/4bYGHx7DvgE';
export const MENTION_ME_SIGN_UP_SCRIPT_BASE_URL = 'https://tag.mention-me.com/api/v2/signup/mm191789f5';
export const MENTION_ME_REFER_BASE_URL = 'https://tag.mention-me.com/api/v2/referreroffer/mm191789f5';
